/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseDTOListTransactionPaymentMethodEnum } from '../models/ApiResponseDTOListTransactionPaymentMethodEnum';
import type { ApiResponseDTOMerchantTransactionDTO } from '../models/ApiResponseDTOMerchantTransactionDTO';
import type { ApiResponseDTOPaginationRecordListTransactionBaseDTO } from '../models/ApiResponseDTOPaginationRecordListTransactionBaseDTO';
import type { ApiResponseDTOTransactionDTO } from '../models/ApiResponseDTOTransactionDTO';
import type { ApiResponseDTOTransactionFullDTO } from '../models/ApiResponseDTOTransactionFullDTO';
import type { CBSTransactionResponse } from '../models/CBSTransactionResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TransactionsApiService {

    /**
     * Get Transactions
     * Retrieves a paginated list of transactions using filters.
     * @param page Which page should be selected.
     * @param size Number of records to select
     * @param direction Indicates whether the content should be sorted ascending or descending
     * @param orderBy Indicates which column should be taken into consideration when sorting
     * @param transactionDateStart Indicates that transactions with a date greater than or equal to this field will be filtered
     * @param transactionDateEnd Indicates that transactions with a date less than or equal to this field will be filtered
     * @param partialTransactionType Indicates what partial transaction type should be filtered
     * @param paymentMethods Indicates what payment method should be filtered
     * @param deviceChannels Indicates what device channel should be filtered
     * @param minimumAmount Indicates that transactions with an amount equal to or greater than the value contained in this field will be filtered
     * @param maximumAmount Indicates that transactions with an amount equal to or less than the value contained in this field sill be filtered
     * @param searchInput Indicates that only the transactions that match with this field will be filtered
     * @param userId Indicates the user id of the transactions to be filtered
     * @param terminalId Indicates the terminal id of the transactions to be filtered
     * @param outletId Outlets whose transactions are listed; repeat for several. Omit for every outlet the caller may act on
     * @param status Indicates the status of the transaction
     * @returns ApiResponseDTOPaginationRecordListTransactionBaseDTO OK
     * @throws ApiError
     */
    public static getTransactions(
        page?: string,
        size?: string,
        direction?: string,
        orderBy?: string,
        transactionDateStart?: string,
        transactionDateEnd?: string,
        partialTransactionType?: string,
        paymentMethods?: string,
        deviceChannels?: string,
        minimumAmount?: string,
        maximumAmount?: string,
        searchInput?: string,
        userId?: string,
        terminalId?: string,
        outletId?: string,
        status?: string,
    ): CancelablePromise<ApiResponseDTOPaginationRecordListTransactionBaseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/transaction',
            query: {
                'page': page,
                'size': size,
                'direction': direction,
                'orderBy': orderBy,
                'transactionDateStart': transactionDateStart,
                'transactionDateEnd': transactionDateEnd,
                'partialTransactionType': partialTransactionType,
                'paymentMethods': paymentMethods,
                'deviceChannels': deviceChannels,
                'minimumAmount': minimumAmount,
                'maximumAmount': maximumAmount,
                'searchInput': searchInput,
                'userId': userId,
                'terminalId': terminalId,
                'outletId': outletId,
                'status': status,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

    /**
     * @param transactionId
     * @returns CBSTransactionResponse OK
     * @throws ApiError
     */
    public static queryCbsTransaction(
        transactionId: string,
    ): CancelablePromise<CBSTransactionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/transaction/cbs/{transactionId}',
            path: {
                'transactionId': transactionId,
            },
            errors: {
                500: `Internal Server Error`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

    /**
     * Export Transactions
     * Retrieves a list of transactions, generate and export it.
     * @param mediaType Indicates what is the export file type
     * @param page Which page should be selected.
     * @param size Number of records to select
     * @param direction Indicates whether the content should be sorted ascending or descending
     * @param orderBy Indicates which column should be taken into consideration when sorting
     * @param transactionDateStart Indicates that transactions with a date greater than or equal to this field will be filtered
     * @param transactionDateEnd Indicates that transactions with a date less than or equal to this field will be filtered
     * @param partialTransactionType Indicates what partial transaction type should be filtered
     * @param paymentMethods Indicates what payment method should be filtered
     * @param deviceChannels Indicates what device channel should be filtered
     * @param minimumAmount Indicates that transactions with an amount equal to or greater than the value contained in this field will be filtered
     * @param maximumAmount Indicates that transactions with an amount equal to or less than the value contained in this field sill be filtered
     * @param transactionId Indicates that only the transactions that match with this field will be filtered
     * @param userId Indicates the user ID
     * @param terminalId The terminal Id associated with the transaction for POS
     * @param userSessionId Indicates the user session Id associated with the transaction for POS
     * @param outletId Outlets whose transactions are exported; repeat for several. Omit for every outlet the caller may act on
     * @param status Indicates the status of the transaction
     * @returns any OK
     * @throws ApiError
     */
    public static export1(
        mediaType?: string,
        page?: string,
        size?: string,
        direction?: string,
        orderBy?: string,
        transactionDateStart?: string,
        transactionDateEnd?: string,
        partialTransactionType?: string,
        paymentMethods?: string,
        deviceChannels?: string,
        minimumAmount?: string,
        maximumAmount?: string,
        transactionId?: string,
        userId?: string,
        terminalId?: string,
        userSessionId?: string,
        outletId?: string,
        status?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/transaction/export',
            query: {
                'mediaType': mediaType,
                'page': page,
                'size': size,
                'direction': direction,
                'orderBy': orderBy,
                'transactionDateStart': transactionDateStart,
                'transactionDateEnd': transactionDateEnd,
                'partialTransactionType': partialTransactionType,
                'paymentMethods': paymentMethods,
                'deviceChannels': deviceChannels,
                'minimumAmount': minimumAmount,
                'maximumAmount': maximumAmount,
                'transactionId': transactionId,
                'userId': userId,
                'terminalId': terminalId,
                'userSessionId': userSessionId,
                'outletId': outletId,
                'status': status,
            },
            errors: {
                500: `Internal Server Error`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

    /**
     * Get List of Transaction Payment Method
     * Retrieves the transaction payment Method list.
     * @returns ApiResponseDTOListTransactionPaymentMethodEnum OK
     * @throws ApiError
     */
    public static getListPaymentMethod(): CancelablePromise<ApiResponseDTOListTransactionPaymentMethodEnum> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/transaction/payment-method',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

    /**
     * Get Session Transactions
     * Retrieves a paginated list of transactions performed by the logged in user.
     * @param page Which page should be selected.
     * @param size Number of records to select
     * @param direction Indicates whether the content should be sorted ascending or descending
     * @param orderBy Indicates which column should be taken into consideration when sorting
     * @param transactionDateStart Indicates that transactions with a date greater than or equal to this field will be filtered
     * @param transactionDateEnd Indicates that transactions with a date less than or equal to this field will be filtered
     * @param partialTransactionType Indicates what partial transaction type should be filtered
     * @param paymentMethods Indicates what payment method should be filtered
     * @param deviceChannels Indicates what device channel should be filtered
     * @param minimumAmount Indicates that transactions with an amount equal to or greater than the value contained in this field will be filtered
     * @param maximumAmount Indicates that transactions with an amount equal to or less than the value contained in this field sill be filtered
     * @param searchInput Indicates that only the transactions that match with this field will be filtered
     * @param userId Indicates the user id of the transactions to be filtered
     * @param terminalId Indicates the terminal id of the transactions to be filtered
     * @param outletId Outlets whose transactions are listed; repeat for several. Omit for every outlet the caller may act on
     * @param status Indicates the status of the transaction
     * @returns ApiResponseDTOPaginationRecordListTransactionBaseDTO OK
     * @throws ApiError
     */
    public static getSessionTransactions(
        page?: string,
        size?: string,
        direction?: string,
        orderBy?: string,
        transactionDateStart?: string,
        transactionDateEnd?: string,
        partialTransactionType?: string,
        paymentMethods?: string,
        deviceChannels?: string,
        minimumAmount?: string,
        maximumAmount?: string,
        searchInput?: string,
        userId?: string,
        terminalId?: string,
        outletId?: string,
        status?: string,
    ): CancelablePromise<ApiResponseDTOPaginationRecordListTransactionBaseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/transaction/session',
            query: {
                'page': page,
                'size': size,
                'direction': direction,
                'orderBy': orderBy,
                'transactionDateStart': transactionDateStart,
                'transactionDateEnd': transactionDateEnd,
                'partialTransactionType': partialTransactionType,
                'paymentMethods': paymentMethods,
                'deviceChannels': deviceChannels,
                'minimumAmount': minimumAmount,
                'maximumAmount': maximumAmount,
                'searchInput': searchInput,
                'userId': userId,
                'terminalId': terminalId,
                'outletId': outletId,
                'status': status,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

    /**
     * Get Transaction by TransactionID
     * Retrieves the Transaction that has the inserted ID.
     * @param transactionId
     * @returns ApiResponseDTOTransactionFullDTO OK
     * @throws ApiError
     */
    public static getTransactionsById(
        transactionId: string,
    ): CancelablePromise<ApiResponseDTOTransactionFullDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/transaction/{transactionId}',
            path: {
                'transactionId': transactionId,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

    /**
     * @param transactionId
     * @returns ApiResponseDTOTransactionDTO OK
     * @throws ApiError
     */
    public static pollTransactionStatus(
        transactionId: string,
    ): CancelablePromise<ApiResponseDTOTransactionDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/transaction/{transactionId}/poll',
            path: {
                'transactionId': transactionId,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

    /**
     * @param walletId
     * @param transactionType
     * @returns ApiResponseDTOMerchantTransactionDTO OK
     * @throws ApiError
     */
    public static checkTransactingMerchant(
        walletId: string,
        transactionType: 'IN' | 'OUT',
    ): CancelablePromise<ApiResponseDTOMerchantTransactionDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/transaction/{walletId}/{transactionType}',
            path: {
                'walletId': walletId,
                'transactionType': transactionType,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

}
